import PageHeader from '../components/layout/PageHeader';
import ServiceGrid from '../components/services/ServiceGrid';
import usePageTitle from '../hooks/usePageTitle';

const INTRO =
  "As an all encompassing animal care center, we provide a huge range of additional services alongside top of the line treatment. From surgeries to online consults and pet relocation, we've got all your animal needs taken care of.";

export default function Services() {
  usePageTitle('Our Services');

  return (
    <>
      <PageHeader eyebrow="What we offer" title="Our Services" intro={INTRO} />
      <section className="section" aria-label="All services">
        <div className="container">
          <ServiceGrid />
        </div>
      </section>
    </>
  );
}
